import { render, staticRenderFns } from "./AddPost.vue?vue&type=template&id=17e63b1e&"
import script from "./AddPost.vue?vue&type=script&lang=js&"
export * from "./AddPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports